/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { colors, HFlow, Tag, Theme, useTheme } from 'bold-ui'
import { TitleGroup } from 'components/TitleGroup'
import { AcompanhamentoCondicaoSaudeTematicaEnum } from 'graphql/types.generated'
import { ReactComponent as TriaListIcon } from 'images/acompanhamento/acompanhamento-condicao-saude/ic_tria_listagem.svg'
import { ReactComponent as IconSaudeMulher } from 'images/acompanhamento/icon-saude-mulher.svg'
import { PecTag } from 'view/atendimentos/list/PecTag'
interface AcompanhamentoCondicaoSaudeTableHeaderProps {
  hasIvcfFilter: boolean
  hasTriaFilter: boolean
  listaTematica: AcompanhamentoCondicaoSaudeTematicaEnum
}

const listaTematicaTags: Record<
  AcompanhamentoCondicaoSaudeTematicaEnum,
  (styles: ReturnType<typeof createStyles>) => JSX.Element | null
> = {
  [AcompanhamentoCondicaoSaudeTematicaEnum.GESTANTE_PUERPERA]: (styles) => (
    <Tag icon='pregnant' style={styles.tagGestantes}>
      Gestação e puerpério
    </Tag>
  ),
  [AcompanhamentoCondicaoSaudeTematicaEnum.PESSOA_IDOSA]: (styles) => (
    <Tag icon='sixtyPlus' style={styles.tagPessoaIdosa}>
      Pessoa idosa
    </Tag>
  ),
  [AcompanhamentoCondicaoSaudeTematicaEnum.GERAL]: () => null,
  [AcompanhamentoCondicaoSaudeTematicaEnum.DESENVOLVIMENTO_INFANTIL]: (styles) => (
    <Tag icon='teddyBear' style={styles.tagDesenvolvimentoInfantil}>
      Desenvolvimento infantil
    </Tag>
  ),
  [AcompanhamentoCondicaoSaudeTematicaEnum.SAUDE_MULHER]: (styles) => (
    <PecTag icon={IconSaudeMulher} style={styles.tagSaudeMulher}>
      Saúde da mulher
    </PecTag>
  ),
  [AcompanhamentoCondicaoSaudeTematicaEnum.SAUDE_BUCAL]: (styles) => (
    <Tag icon='toothFilled' style={styles.tagSaudeBucal}>
      Saúde bucal
    </Tag>
  ),
  [AcompanhamentoCondicaoSaudeTematicaEnum.DIABETES]: (styles) => (
    <Tag icon='glucometer' style={styles.tagDiabetes}>
      Diabetes
    </Tag>
  ),
  [AcompanhamentoCondicaoSaudeTematicaEnum.HIPERTENSAO_ARTERIAL]: (styles) => (
    <Tag icon='bloodPressureFilled' style={styles.tagHipertensao}>
      Hipertensão
    </Tag>
  ),
}

export const AcompanhamentoCondicaoSaudeTableHeader = (props: AcompanhamentoCondicaoSaudeTableHeaderProps) => {
  const { hasIvcfFilter, hasTriaFilter, listaTematica } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <HFlow hSpacing={0.5} style={styles.titleResultadosEncontrados} alignItems='center'>
      <TitleGroup title='Resultados encontrados' />
      {listaTematicaTags[listaTematica]?.(styles)}
      {hasIvcfFilter && (
        <Tag style={styles.tagIvcf}>
          <HFlow alignItems='center' hSpacing={0}>
            <span css={styles.labelIvcf}>60+</span>
            <span>IVCF-20</span>
          </HFlow>
        </Tag>
      )}
      {hasTriaFilter && (
        <Tag style={styles.tagTria} icon={TriaListIcon}>
          <span css={styles.textTria}>TRIA</span>
        </Tag>
      )}
    </HFlow>
  )
}

const createStyles = (theme: Theme) => ({
  titleResultadosEncontrados: css`
    margin-bottom: 1rem;
  `,
  tagIvcf: css`
    background-color: ${colors.green.c60};
    color: ${theme.pallete.surface.main};
  `,
  labelIvcf: css`
    font-size: 0.5rem;
    margin-right: 0.5rem;
  `,
  tagGestantes: css`
    background-color: ${colors.purple.c60};
    color: ${theme.pallete.gray.c100};
  `,
  tagPessoaIdosa: css`
    background-color: ${colors.green.c60};
    color: ${theme.pallete.gray.c100};
  `,
  tagDesenvolvimentoInfantil: css`
    background-color: ${colors.turquoise.c60};
    color: ${theme.pallete.gray.c100};
  `,
  tagDiabetes: css`
    background-color: ${colors.red.c20};
    color: ${theme.pallete.gray.c100};
  `,
  tagHipertensao: css`
    background-color: ${colors.yellow.c40};
    color: ${theme.pallete.gray.c100};
  `,
  tagTria: css`
    background-color: ${colors.turquoise.c40};
    color: ${theme.pallete.surface.main};
    margin-right: 0.5rem;
  `,
  textTria: css`
    margin-left: 0.25rem;
  `,
  tagSaudeMulher: css`
    background-color: ${colors.pink.c40};
    color: ${theme.pallete.gray.c100};
  `,
  tagSaudeBucal: css`
    background-color: ${colors.orange.c40};
    color: ${theme.pallete.surface.main};
  `,
})
